import { render, staticRenderFns } from "./ReportsEditTabContent.vue?vue&type=template&id=0fa679f2&"
import script from "./ReportsEditTabContent.vue?vue&type=script&lang=js&"
export * from "./ReportsEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./ReportsEditTabContent.vue?vue&type=style&index=0&id=0fa679f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports